import { render, staticRenderFns } from "./ImageSection.vue?vue&type=template&id=41a15c1a&scoped=true&"
import script from "./ImageSection.vue?vue&type=script&lang=js&"
export * from "./ImageSection.vue?vue&type=script&lang=js&"
import style0 from "./ImageSection.vue?vue&type=style&index=0&id=41a15c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a15c1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCol,VImg,VRow,VSkeletonLoader})
